import { Drivers, PaginatedResponse, Response } from "Data/interfaces";
import { baseApi } from "./baseApi";
import { RouteForm } from "Pages/CreateRoute/createRoute";

export const driversApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createDriver: builder.mutation<Response<RouteForm>, unknown>({
      query: (data) => {
        return {
          url: "driver",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getDrivers: builder.query<PaginatedResponse<Drivers>, { page: number }>({
      query: ({ page }) => {
        return {
          url: `driver?page=${page}`,
          method: "Get",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    updateDriver: builder.mutation<Response<Drivers>, unknown>({
      query: ({ formData, id }) => {
        return {
          url: `driver/${id}`,
          method: "PATCH",
          body: formData,
        };
      },
    }),
    deleteDriver: builder.mutation<Response<Drivers>, { id: number | string }>({
      query: ({ id }) => {
        return {
          url: `driver/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useCreateDriverMutation,
  useLazyGetDriversQuery,
  useUpdateDriverMutation,
  useDeleteDriverMutation,
} = driversApi;
